import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderBread from "../../../../../../components/HeaderBread";
import CustomHeaderTitle from "../../../../../../components/constants/CustomHeaderTitle";
import Layout from "../../../../../../Layout";
import EntertainmentItemizerInput from "../../../../../../components/EntertainmentItemizerInput";
import { useDataLayerValue } from "../../../../../../DataLayer/DataLayer";
import {
  getEntertainmentRvc,
  getEntertainmentItemizer,
} from "../../../../../../utils/ApiCalls/BackOffice/Entertainment";

const LIST_PATH = "/shore/back-office/entertainment/revenue-center";

const EditItemizer = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [rvc, setRvc] = useState(null);
  const [itemizer, setItemizer] = useState(null);
  const [, dispatch] = useDataLayerValue();

  useEffect(() => {
    const loadData = async () => {
      dispatch({ type: "SET_LOADING", loading: true });
      const [rvcData, itemizerData] = await Promise.all([
        getEntertainmentRvc(params.id),
        getEntertainmentItemizer(params.itemizerId),
      ]);
      if (!rvcData.error) setRvc(rvcData);
      if (!itemizerData.error) setItemizer(itemizerData);
      dispatch({ type: "SET_LOADING", loading: false });
    };
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id, params.itemizerId]);

  const basePath = `${LIST_PATH}/${params.id}`;

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Revenue Center", route: LIST_PATH },
    { title: rvc?.name || "Revenue Center", route: basePath },
    { title: "Edit Itemizer", route: `${basePath}/itemizer/edit/${params.itemizerId}` },
  ];

  return (
    <Layout type={"update_per"} module_data={"Revenue Center"}>
      <CustomHeaderTitle title={"Edit Itemizer"} />
      <HeaderBread navigation={navigation} title={"Edit Itemizer"}></HeaderBread>
      {itemizer?.isDeleted === 0 && (
        <div className="container-fluid">
          <div className="alert alert-secondary" role="alert">
            This record has been removed - showing a read-only view.
          </div>
        </div>
      )}
      {rvc && itemizer && (
        <EntertainmentItemizerInput
          rvcId={rvc.id}
          rvcName={rvc.name}
          itemizer={itemizer}
          readOnly={itemizer?.isDeleted === 0}
          onSuccess={() =>
            navigate(basePath, { state: { topTab: "itemizer" } })
          }
        />
      )}
    </Layout>
  );
};

export default EditItemizer;
